import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { ALIGN_OPTIONS, ALIGN_SELF_OPTIONS, DIRECTION_OPTIONS, JUSTIFY_OPTIONS, WRAP_OPTIONS } from './FlexConstants';
import { toPx } from '../utils/Styles';
import { useFoundationsReadinessTracking } from '../utils/useFoundationsReadinessTracking';

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "UIFlex__StyledFlex",
  componentId: "sc-6wfmpe-0"
})(["align-items:", ";align-self:", ";flex-direction:", ";justify-content:", ";flex-wrap:", ";gap:", ";display:flex;flex-grow:1;max-width:100%;width:100%;& > .private-flex{width:auto;}"], ({
  align
}) => align && ALIGN_OPTIONS[align], ({
  alignSelf
}) => alignSelf && ALIGN_SELF_OPTIONS[alignSelf], ({
  direction
}) => direction && DIRECTION_OPTIONS[direction], ({
  justify
}) => justify && JUSTIFY_OPTIONS[justify], ({
  wrap
}) => wrap && WRAP_OPTIONS[wrap], ({
  gap
}) => gap && toPx(gap));
const UIFlex = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useFoundationsReadinessTracking();
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({}, rest, {
    className: cx('private-flex', className),
    ref: ref
  }));
});
UIFlex.propTypes = {
  align: PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  alignSelf: PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  children: PropTypes.node,
  direction: PropTypes.oneOf(Object.keys(DIRECTION_OPTIONS)),
  justify: PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  wrap: PropTypes.oneOf(Object.keys(WRAP_OPTIONS)),
  gap: PropTypes.number
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIFlex.defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap',
  gap: 0
};
UIFlex.displayName = 'UIFlex';
export default UIFlex;